<template>
  <div :class="[tag, `${tag}-${position}`]" v-if="services.length">
    <ul>
      <li v-for="(service, index) in services" :key="index">
        <a @click.prevent="popup(service.url(url, title), '', popupWidth, popupHeight)" rel="noopener" :href="service.url(url, title)" :title="firstLetterCapital(service.icon)">
          <i :class="['mdi', `mdi-${service.icon}`]" aria-hidden="true" />
        </a>
      </li>
    </ul>
    <link rel="stylesheet" href="//cdnjs.cloudflare.com/ajax/libs/MaterialDesign-Webfont/2.0.46/css/materialdesignicons.min.css" />
    <vc-style>
      .vc-social-bar
      {
        z-index: {{ zIndex }};
        background: {{ bgColor }};
        box-shadow: {{ shadow }};
        backdrop-filter: blur({{ backdropBlur }}px);
      }

      .vc-social-bar .mdi {
        font-size: {{ fontSize }}em;
      }

      .vc-social-bar a,
      .vc-social-bar .mdi {
        color: {{ color }};
      }
    </vc-style>
  </div>
</template>
<script>
import VcStyle from './style'

export default {
  name: 'VcSocialBar',
  components: {
    VcStyle
  },
  data () {
    return {
      tag: 'vc-social-bar',
      url: window.location.href
    }
  },
  props: {
    popupWidth: {
      type: Number,
      required: false,
      default: 640
    },
    popupHeight: {
      type: Number,
      required: false,
      default: 640
    },
    services: {
      type: Array,
      required: false,
      default: () => []
    },
    title: {
      type: String,
      required: false,
      default: null
    },
    fontSize: {
      type: Number,
      default: 2
    },
    color: {
      type: String,
      required: false,
      default: '#f2f2f2'
    },
    position: {
      type: String,
      required: false,
      default: 'left'
    },
    bgColor: {
      type: String,
      required: false,
      default: 'rgba(0, 0, 0, .75)'
    },
    backdropBlur: {
      type: Number,
      required: false,
      default: 5
    },
    shadow: {
      type: String,
      required: false,
      default: '0 0 .5em rgba(0, 0, 0, 1)'
    },
    zIndex: {
      type: Number,
      required: false,
      default: 1000
    }
  },
  methods: {
    /**
     * Capitalize the first letter of a string
     * @method capitalize
     * @param {number} index
     * @return {string}
     */
    firstLetterCapital (string) {
      if (typeof string !== 'string') {
        return ''
      }
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    /**
     * Open url in a popup
     * @method popup
     * @param {string} url
     * @param {string} title
     * @param {number} width
     * @param {number} height
     * @return {object}
     */
    popup (url = window.location.href, title = '', width = 640, height = 480) {
      const left = (screen.width / 2) - (width / 2)
      const top = (screen.height / 2) - (height / 2)
      return window.open(url, title, `width=${width}, height=${height}, top=${top}, left=${left}, toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no`)
    }
  }
}
</script>
<style>
.vc-social-bar ul,
.vc-social-bar li
{
  margin: 0;
  padding: 0;
  list-style: none;
}

.vc-social-bar-top,
.vc-social-bar-bottom
{
  left: 50%;
  transform: translateX(-50%);
}

.vc-social-bar-left,
.vc-social-bar-right
{
  top: 50%;
  transform: translateY(-50%);
}

.vc-social-bar-top li,
.vc-social-bar-bottom li
{
  display: inline-block;
  vertical-align: middle;
}

.vc-social-bar-top ul,
.vc-social-bar-bottom ul
{
  white-space: nowrap;
}

.vc-social-bar *
{
  outline: 0;
}

.vc-social-bar
{
  position: fixed;
  padding: .25em;
  user-select: none;
}

.vc-social-bar a
{
  display: block;
  text-align: center;
}

.vc-social-bar-top
{
  top: .25em;
}

.vc-social-bar-right
{
  right: .25em;
}

.vc-social-bar-bottom
{
  bottom: .25em;
}

.vc-social-bar-left
{
  left: .25em;
}
</style>



// WEBPACK FOOTER //
// vc-social-bar.vue?049cdffc